<template>
  <tr v-if="forPrint && productHasNote" class="b2b-grid__secondary-row">
    <td class="b2b-grid__cell lg:table-cell" qaid="sku-grid.icon">
      <i class="b2b-grid__icon material-icons">note_add</i>
    </td>

    <td class="b2b-grid__cell lg:table-cell" qaid="sku-grid.note" colspan="9">
      <div class="b2b-grid__content italic text-gray-80">
        {{ item.lineNote }}
      </div>
    </td>
  </tr>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    forPrint: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    productHasNote() {
      return this.item && !isEmpty(this.item.lineNote);
    },
  },
};
</script>
